<template>
  <fixed-nav
    class="fixed-side-bar-inside-fixed-top"
    style="height: 100%"
    :heightOfNavInPixels="heightOfNavInPixels"
  >
    <div class="nav-slot" style="overflow-y: hidden" slot="nav-slot">
      <slot name="top-nav" />
    </div>
    <!-- <fixed-side class="body-slot" :bodyID="bodyID" :sizeOfFixedSideInPixels="sizeOfFixedSideInPercent" slot="body-slot"> -->
    <fixed-side
      class="body-slot"
      :bodyID="bodyID"
      :sizeOfFixedSideInPixels="sizeOfFixedSideInPixels"
      :navBackgroundColor="nav_background_color"
      :style="{ 'background-color': bodyBackgroundColor }"
      slot="body-slot"
    >
      <div class="side-nav-slot" slot="side-nav-slot">
        <slot name="side-nav" />
      </div>
      <div
        class="side-body-slot"
        style="position: inherit"
        slot="side-body-slot"
      >
        <slot name="body" />
      </div>
    </fixed-side>
    <slot name="dialogs" />
  </fixed-nav>
</template>

<script>
  import './fixedSideBarInsideFixedTop.styl';
  import FixedNav from 'layouts/fixedNavBar/fixedNavBar';
  import FixedSide from 'layouts/fixedSideBar/fixedSideBar';

  export default {
    data() {
      return {};
    },
    computed: {
      nav_background_color() {
        return this.navBackgroundColor;
      },
    },
    props: {
      bodyBackgroundColor: {
        type: String,
        default: '#f0f0f0',
      },
      navBackgroundColor: {
        type: String,
        default: '#f0f0f0',
      },
      sizeOfFixedSideInPixels: {
        type: Number,
        default: -1,
      },
      sizeOfFixedSideInPercent: {
        type: Number,
        default: 20,
      },
      heightOfNavInPixels: {
        type: Number,
        default: 50,
      },
      bodyID: {
        type: String,
        default: null,
      },
    },
    components: {
      FixedNav,
      FixedSide,
    },
  };
</script>



// WEBPACK FOOTER //
// fixedSideBarInsideFixedTop.vue?e8f3ef62